import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import MainHeader from "../../Pages/Header/HeaderForBus";
import FooterStyle from '../../Pages/Footer/Footer';
import API from '../../Api/Api';
import { IMAGE_PATHS, DOMAIN_URL, BASE_URL_A } from '../../Functions/Constant';
import ConfirmationPopup from '../../Components/ConfirmationPopup';
import Confin from '../../Components/confin';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from 'firebase/auth';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import Select from 'react-select';
import countries from 'i18n-iso-countries';
import './ProfilePage.css';
import Loader from "../../Components/Loader";
import axios from 'axios';
import MediaUpload from '../../Components/MediaUpload/MediaUpload';
import MediaPreview from '../../Components/MediaUpload/MediaPreview';
import WelcomePopupBus from '../../Pages/ComponentPage/WelcomePopupBus';
import ButtonsVariant from '../../Components/Button/ButtonVariant'; // Fixed: Use default import

// Register i18n-iso-countries English locale
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

// Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyA2P9-Fhbu_1CBKYR2YuHyWPZO_4euTs_s",
    authDomain: "phoneverification-6a78e.firebaseapp.com",
    projectId: "phoneverification-6a78e",
    storageBucket: "phoneverification-6a78e.firebasestorage.app",
    messagingSenderId: "315297057884",
    appId: "1:315297057884:web:0f944fcb3e8b13e9146a99"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Generate country code options using libphonenumber-js and i18n-iso-countries
const countryCodeOptions = getCountries()
    .map(country => ({
        value: `+${getCountryCallingCode(country)}`,
        label: `+${getCountryCallingCode(country)} (${countries.getName(country, 'en') || country})`
    }))
    .sort((a, b) => {
        if (a.value === "+1") return -1;
        if (b.value === "+1") return 1;
        return a.label.localeCompare(b.label);
    });

const getCountryCodeFromNetwork = async () => {
    try {
        const ipResponse = await axios.get('https://api.ipify.org?format=json');
        const ip = ipResponse.data.ip;

        if (!ip) {
            console.warn("No IP address found, defaulting to +1");
            return "+1";
        }

        const geoResponse = await axios.get(`https://ipapi.co/${ip}/json`);
        const { country_code } = geoResponse.data;

        if (country_code) {
            const phoneCountryCode = `+${getCountryCallingCode(country_code)}`;
            if (countryCodeOptions.find(option => option.value === phoneCountryCode)) {
                return phoneCountryCode;
            } else {
                console.warn(`Country code ${country_code} not supported in countryCodeOptions, defaulting to +1`);
                return "+1";
            }
        } else {
            console.warn("No country code found from ipapi.co, defaulting to +1");
            return "+1";
        }
    } catch (error) {
        console.error("Error fetching geolocation from ipapi.co:", error);
        return "+1";
    }
};

const BusinessForm = () => {
    const [profilePic, setProfilePic] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [imageError, setImageError] = useState("");
    const [locationquery, setLocationquery] = useState("");
    const [locationsuggestions, setLocationSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [emailValue, setEmailValue] = useState("");
    const [error, setError] = useState("");
    const [formValues, setFormValues] = useState({
        countryCode: "+1",
        companyName: "",
        website: "",
        industry: "",
        companysize: "",
        address: "",
        repFullName: "",
        repJobTitle: "",
        repLinkedIn: "",
        phone: "",
        location: "", // Added for location (city_id)
        secContact: "",
        secEmail: ""
    });
    const [popupData, setPopupData] = useState({
        isOpen: false,
        title: "",
        message: "",
        onClose: () => { },
        onConfirm: () => { },
        onComplete: () => { },
    });
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [confirmationResult, setConfirmationResult] = useState(null);
    const [otpError, setOtpError] = useState("");
    const [isPhoneVerified, setIsPhoneVerified] = useState(true);
    const [originalPhone, setOriginalPhone] = useState("");
    const [countryCode, setCountryCode] = useState("+1");
    const [tempCountryCode, setTempCountryCode] = useState(formValues.countryCode);
    const [mediaFiles, setMediaFiles] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(true); // Show popup initially
    const handleClosePopup = () => {
        setIsPopupOpen(false); // Close the popup
    };
    const handleMediaUpload = (files) => {
        const newFiles = Array.from(files).map((file) => ({
            file,
            url: URL.createObjectURL(file),
        }));
        setMediaFiles((prev) => [...prev, ...newFiles]);
    };

    const handleRemoveMedia = (index) => {
        setMediaFiles((prev) => {
            const fileToRemove = prev[index];
            URL.revokeObjectURL(fileToRemove.url); // Clean up URL
            return prev.filter((_, i) => i !== index);
        });
    };

    useEffect(() => {
        window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
            size: 'invisible',
            callback: () => { }
        });
    }, [auth]);

    const validationSchema = Yup.object().shape({
        phone: Yup.string()
            .matches(/^[0-9]{1,20}$/, "Only numbers allowed (Max 20 digits)")
            .required("Phone number is required"),
        countryCode: Yup.string()
            .required("Country code is required")
            .oneOf(countryCodeOptions.map(option => option.value), "Select a valid country code"),
        companyName: Yup.string().required("Company name is required"),
        website: Yup.string()
            .required('Website is required')
            .matches(
                /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/,
                'Must be a valid URL or domain (e.g., example.com or https://example.com)'
            ),
        industry: Yup.string().required("Industry is required").oneOf([
            "1", "2", "3", "4", "5", "6", "7", "8", "9"
        ], "Select a valid industry"),
        companysize: Yup.string().required("Company size is required").oneOf([
            "1", "2", "3", "4", "5", "6"
        ], "Select a valid company size"),
        address: Yup.string(),
        repFullName: Yup.string().required("Full name is required"),
        repJobTitle: Yup.string().required("Job title is required"),
        repLinkedIn: Yup.string()
            .nullable()
            .optional()
            .test('is-linkedin-url', 'Must be a valid LinkedIn profile URL', (value) => {
                if (!value) return true; // Allow empty or null (optional field)
                const linkedinRegex = /^(?:(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/[\w\-]+\/?)?$/;
                return linkedinRegex.test(value);
            }),
        location: Yup.string().required("Location is required"), // Added validation for location
        secContact: Yup.string()
            .nullable()
            .optional()
            .matches(/^[0-9+]{0,20}$/, "Only numbers and + allowed (Max 20 digits)"), // Allow numbers and +
        secEmail: Yup.string()
            .email("Must be a valid email address")
            .nullable()
            .optional()
    });

    const fetchLocation = async (search) => {
        if (!search) {
            setLocationSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            const response = await API.get(`/autocomplete/locations?query=${encodeURIComponent(search)}`);

            const locationList = Array.isArray(response) ? response : [];

            setLocationSuggestions(locationList);
        } catch (error) {
            console.error("Error fetching locationList:", error);
            setLocationSuggestions([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchDataUser = async () => {
        try {
            const defaultCountryCode = await getCountryCodeFromNetwork();
            const res = await API.get(`/business`);
            if (res.business.phone_number) {
                const fetchedCountryCode = res.business.countryCode || defaultCountryCode;
                if (!countryCodeOptions.find(option => option.value === fetchedCountryCode)) {
                    console.warn(`Unsupported countryCode from backend: ${fetchedCountryCode}, defaulting to +1`);
                }
                setTempCountryCode(fetchedCountryCode);
                const userData = {
                    companyName: res.business.company_name || "",
                    website: res.business.website || "",
                    industry: res.business.industry_id || "",
                    companysize: res.business.size_id || "",
                    address: res.business.address || "",
                    repFullName: res.business.full_name || "",
                    repJobTitle: res.business.job_title || "",
                    repLinkedIn: res.business.linkedin_url || "",
                    phone: res.business.phone || "",
                    doc1: res.business.documents[0]?.file_name || undefined,
                    doc2: res.business.documents[1]?.file_name || undefined,
                    secContact: res.business.secondary_contact_phone || "",
                    secEmail: res.business.secondary_contact_email || "",
                    countryCode: fetchedCountryCode,
                    location: res.business.city_id
                };
                setFormValues(userData);
                setLocationquery(res.business.city_name + `, ` + res.business.state_name + `, ` + res.business.country_name);
                const initialMediaFiles = await Promise.all(
                    res.business.documents.map(async (doc) => {
                        try {
                            // Replace with your server's endpoint to fetch the file
                            const response = await fetch(BASE_URL_A + `/uploads/company_documents/${doc.file_name}`); // or `/files/${doc.file_name}`
                            //const response = await fetch(`https://jobcritics.com/assets/img/biar/1.webp`); // or `/files/${doc.file_name}`
                            if (!response.ok) throw new Error(`Failed to fetch ${doc.file_name}`);
                            const blob = await response.blob();
                            const file = new File([blob], doc.file_name, { type: doc.file_type });
                            return {
                                file,
                                url: URL.createObjectURL(blob), // Create blob URL for preview
                                document_id: doc.document_id, // Store for submission
                            };
                        } catch (error) {
                            console.error(`Failed to fetch ${doc.file_name}:`, error);
                            return {
                                file: new File([doc.file_name], doc.file_name, { type: doc.file_type }),
                                url: null, // Use null to indicate failure
                                error: `Failed to load ${doc.file_name}`,
                                document_id: doc.document_id,
                            };
                        }
                    })
                );
                // Filter out files with errors if desired
                setMediaFiles(initialMediaFiles.filter((file) => file.url));
                if (res.business.user.phone_number) {
                    setPhoneNumber(res.business.user.phone_number);
                    setCountryCode(fetchedCountryCode);
                    setOriginalPhone(res.business.user.phone_number);
                    setIsPhoneVerified(true);
                    setFormValues(prev => ({ ...prev, phone: res.business.user.phone_number, countryCode: fetchedCountryCode }));
                } else {
                    setPhoneNumber("");
                    setIsPhoneVerified(false);
                }
                setCountryCode(fetchedCountryCode);
                setSelectedCountryCodeName(countryCodeOptions.find(option => option.value === fetchedCountryCode).label); // Set the selected country code name
                setEmailValue(res.business.user.email);
            } else {
                setPhoneNumber("");
                setIsPhoneVerified(false);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };
    const fetchDataUserOld = async () => {
        try {
            const defaultCountryCode = await getCountryCodeFromNetwork();
            const res = await API.get(`/user`);
            if (res.user) {
                const fetchedCountryCode = res.user.countryCode || defaultCountryCode;
                if (!countryCodeOptions.find(option => option.value === fetchedCountryCode)) {
                    console.warn(`Unsupported countryCode from backend: ${fetchedCountryCode}, defaulting to +1`);
                }
                setTempCountryCode(fetchedCountryCode);
                const userData = {
                    ...formValues,
                    countryCode: fetchedCountryCode
                };
                setFormValues(userData);
                if (res.user.phone) {
                    setPhoneNumber(res.user.phone);
                    setCountryCode(fetchedCountryCode);
                    setOriginalPhone(res.user.phone);
                    setIsPhoneVerified(true);
                    setFormValues(prev => ({ ...prev, phone: res.user.phone, countryCode: fetchedCountryCode }));
                } else {
                    setPhoneNumber("");
                    setIsPhoneVerified(false);
                    setFormValues(prev => ({ ...prev, phone: "", countryCode: fetchedCountryCode }));
                }
                setCountryCode(fetchedCountryCode);
                setSelectedCountryCodeName(countryCodeOptions.find(option => option.value === fetchedCountryCode).label); // Set the selected country code name
                setEmailValue(res.user.email);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    useEffect(() => {
        fetchDataUser();
    }, []);

    const sendOTP = async (phone) => {
        if (isPhoneVerified) {
            setIsPhoneVerified(false);
            return;
        }
        try {
            setLoading(true);
            const phoneNumberWithCode = `${countryCode}${phone}`;
            const confirmation = await signInWithPhoneNumber(auth, phoneNumberWithCode, window.recaptchaVerifier);
            setConfirmationResult(confirmation);
            setShowOTPModal(true);
            setOtpError("");
        } catch (error) {
            setOtpError("Failed to send OTP. Please try again.");
            console.error("OTP Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const verifyOTP = async () => {
        try {
            setLoading(true);
            await confirmationResult.confirm(otp);
            setShowOTPModal(false);
            setOtp("");
            setIsPhoneVerified(true);
            const payload = { phone: phoneNumber, countryCode };
            await API.put('/user/update-countrycode-phone', payload);
            setPopupData({
                isOpen: true,
                title: "Success!",
                message: "Phone number verified successfully.",
                onConfirm: () => setPopupData({ isOpen: false }),
                onClose: () => setPopupData({ isOpen: false }),
                actionType: 'success'
            });
        } catch (error) {
            setOtpError("Invalid OTP. Please try again.");
            console.error("OTP Verification Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleProfilePicChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file.type;
            const fileSize = file.size;
            if (!["image/png", "image/jpeg", "image/jpg"].includes(fileType)) {
                setImageError("Only PNG, JPG, and JPEG formats are allowed.");
                return;
            }
            if (fileSize > 1024 * 1024) {
                setImageError("File size must be less than 1MB.");
                return;
            }
            setFile(file);
        }
    };

    const dataURLtoFile = (dataUrl, filename) => {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };

    const uploadChangePhoto = async (fileUrl) => {
        const file = dataURLtoFile(fileUrl, 'edited-photo.png');
        setFile(file);
        uploadProfilePic(file);
    };

    const uploadProfilePic = async (file) => {
        if (!file) {
            setImageError("Please select an image.");
            return;
        }
        const formData = new FormData();
        formData.append("profile_pic", file);
        const token = localStorage.getItem('jwt_token_jobcritic');
        try {
            const result = await API.post('/user/upload-profile-pic', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                },
            });
            setProfilePic(URL.createObjectURL(file));
            setImageError("");
            setShowPopup(false);
            localStorage.removeItem('userData');
            window.location.reload();
        } catch (error) {
            console.error("Upload failed:", error);
            setImageError("Failed to upload image. Please try again.");
        }
    };

    const finalOkButton = () => {
        setPopupData({ isOpen: false });
        localStorage.removeItem("userData");

        if (localStorage.getItem("redirectPath_jobcritic")) {
            window.location.href = localStorage.getItem("redirectPath_jobcritic");
        } else {
            window.location.href = "/verifications"; // Page reload ke saath redirect karega
        }

        //window.location.href = "/verifications";
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        try {
            // Create FormData to handle file uploads and form fields
            const formData = new FormData();
            formData.append("phone_number", values.phone);
            formData.append("countryCode", values.countryCode);
            formData.append("company_name", values.companyName);
            formData.append("website", values.website);
            formData.append("industry_id", values.industry);
            formData.append("size_id", values.companysize);
            formData.append("address", values.address || "");
            formData.append("full_name", values.repFullName);
            formData.append("job_title", values.repJobTitle);
            formData.append("linkedin_url", values.repLinkedIn || "");
            formData.append("secondary_contact_phone", values.secContact || "");
            formData.append("secondary_contact_email", values.secEmail || "");
            formData.append("email", emailValue);
            formData.append("location_id", values.location); // Append city_id
            //            formData.append("location_string", locationquery); // Append full location string as fallback

            // Append all files from mediaFiles
            mediaFiles.forEach((media, index) => {
                formData.append("documents", media.file); // Use media.file to append the raw File object
            });

            // Log FormData contents for debugging
            for (let pair of formData.entries()) {
                console.log(`${pair[0]}: ${pair[1]}`);
            }

            // Make the API request with FormData
            await API.post('/business', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${localStorage.getItem('jwt_token_jobcritic')}`,
                },
            });

            // Check non-mandatory fields for full submission
            const nonMandatoryFields = {
                address: values.address,
                repLinkedIn: values.repLinkedIn,
                secContact: values.secContact,
                secEmail: values.secEmail
            };
            const allNonMandatoryFilled = Object.values(nonMandatoryFields).every(field => field && field.toString().trim() !== "");

            // Check if documents are uploaded
            const documentsUploaded = mediaFiles.length > 0;

            if (documentsUploaded && allNonMandatoryFilled) {
                setPopupData({
                    isOpen: true,
                    title: "Thanks for the Complete Submission",
                    message: "Your business account is under verification. Once approved, all features will be fully unlocked. Meanwhile, you can view applicant profiles and explore ratings.",
                    onConfirm: () => finalOkButton(),
                    onClose: () => setPopupData({ isOpen: false }),
                    showCancelButton: false,
                    actionType: "success"
                });
            } else {
                setPopupData({
                    isOpen: true,
                    title: "Complete Your Business Verification",
                    message: "Your business details are incomplete. Please fill all fields and upload necessary documents to complete your account verification within the next 7 days.",
                    onConfirm: () => setPopupData({ isOpen: false }),
                    onClose: () => finalOkButton(),
                    showCancelButton: true,
                    onCancel: () => setPopupData({ isOpen: false }),
                    actionType: "remindmelater"
                });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setPopupData({
                isOpen: true,
                title: "Submission Error",
                message: "There was an error submitting your form. Please try again.",
                onConfirm: () => setPopupData({ isOpen: false }),
                onClose: () => setPopupData({ isOpen: false }),
                showCancelButton: false,
                actionType: "error"
            });
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    const CustomSelect = ({ label, name, options, onChange }) => (
        <div className="col-md-12 pb-2">
            <label className="block text-sm font-semibold text-gray-600">{label} *</label>
            <div className="relative">
                <Field
                    as="select"
                    name={name}
                    className="form-control fomc-cls px-3 py-2 w-full appearance-none border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={onChange}
                >
                    <option value="" disabled>Select {label}</option>
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </Field>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>
            <ErrorMessage name={name} component="p" className="text-red-500 text-xs mt-1" />
        </div>
    );

    const industryOptions = [
        { value: "1", label: "Information Technology" },
        { value: "2", label: "Finance and Banking" },
        { value: "3", label: "Healthcare" },
        { value: "4", label: "Education" },
        { value: "5", label: "Manufacturing" },
        { value: "6", label: "Retail & E-commerce" },
        { value: "7", label: "Hospitality" },
        { value: "8", label: "Marketing & Advertising" },
        { value: "9", label: "Others" }
    ];
    const sizeOptions = [
        { value: "1", label: "1–10 employees" },
        { value: "2", label: "11–50 employees" },
        { value: "3", label: "51–200 employees" },
        { value: "4", label: "201–500 employees" },
        { value: "5", label: "501–1000 employees" },
        { value: "6", label: "1000+ employees" }
    ];
    const [selectedCountryCodeName, setSelectedCountryCodeName] = useState("");
    return (
        <div className="profile-page">
            <div id="recaptcha-container"></div>
            <MainHeader />
            <section className="pt-[120px] pb-[120px] md:pt-[30px] sm:pt-[30px] xs:pr-[15px] xs:pl-[15px]">
                <Container className="mx-auto border-1 p-6 rounded-lg" >
                    <Row>
                        <Col lg={12} md={12} xs={12} className="mb-6 md:mb-0">
                            <h3 className="text-[28px] font-bold text-black mb-0 text-[#000] xs:text-[22px]">Organization Verification Form</h3>
                        </Col>
                        <hr className="border-t border-gray-500" />

                        <Col lg={12} md={12} sm={12}>
                            <Formik
                                enableReinitialize
                                initialValues={formValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ values, handleChange, setFieldValue, handleSubmit, dirty }) => (
                                    <Form onSubmit={handleSubmit}>
                                        {/* Company Details */}
                                        <div className="text-lg font-bold text-gray-900 modal-title h4 mt-4 mb-4">Company Details</div>
                                        <Row>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Company Name *</label>
                                                <Field
                                                    type="text"
                                                    name="companyName"
                                                    placeholder="ABC Technologies Pvt Ltd"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="companyName" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Website *</label>
                                                <Field
                                                    type="text"
                                                    name="website"
                                                    placeholder="https://www.abctech.com"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="website" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6} className="pb-2">
                                                <CustomSelect
                                                    label="Industry"
                                                    name="industry"
                                                    options={industryOptions}
                                                    onChange={handleChange}
                                                />
                                            </Col>
                                            <Col md={6} className="pb-2">
                                                <CustomSelect
                                                    label="Company Size"
                                                    name="companysize"
                                                    options={sizeOptions}
                                                    onChange={handleChange}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Registered Address</label>
                                                <Field
                                                    type="text"
                                                    name="address"
                                                    placeholder="New York, USA"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="address" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                            <Col md={6} className="pb-2 position-relative">
                                                <label className="block text-sm font-semibold text-gray-600">Location *</label>
                                                <Field
                                                    type="text"
                                                    name="location"
                                                    className="form-control fomc-cls"
                                                    placeholder="Location..."
                                                    value={locationquery}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setLocationquery(value);
                                                        if (value.length > 1) {
                                                            fetchLocation(value);
                                                        } else {
                                                            setFieldValue("location", '');
                                                            setLocationSuggestions([]);
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        setTimeout(() => {
                                                            setLocationSuggestions([]);
                                                        }, 200);
                                                    }}
                                                    autoComplete="off"
                                                />
                                                <ErrorMessage name="location" component="div" className="text-danger text-sm" />

                                                {locationsuggestions.length > 0 && (
                                                    <ul className="list-group position-absolute mt-1 bg-white shadow-lg rounded z-[1000]"
                                                        style={{
                                                            width: '94%',
                                                        }}>
                                                        {locationsuggestions.map((locationVal, index) => (
                                                            <li
                                                                key={locationVal.city_id}
                                                                className="list-group-item list-group-item-action"
                                                                onClick={() => {
                                                                    setLocationquery(locationVal.city_name + `, ` + locationVal.state_name + `, ` + locationVal.country_name);
                                                                    setFieldValue("location", locationVal.city_id);
                                                                    setLocationSuggestions([]);
                                                                }}
                                                            >
                                                                {locationVal.city_name + `, ` + locationVal.state_name + `, ` + locationVal.country_name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </Col>
                                        </Row>
                                        <hr className="my-4 border-t border-gray-500" />

                                        {/* Representative Details */}
                                        <div className="text-lg font-bold text-gray-900 modal-title h4 mt-4 mb-4">Representative Details</div>
                                        <Row>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Full Name *</label>
                                                <Field
                                                    type="text"
                                                    name="repFullName"
                                                    placeholder="John Doe"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="repFullName" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Job Title *</label>
                                                <Field
                                                    type="text"
                                                    name="repJobTitle"
                                                    placeholder="HR Manager"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="repJobTitle" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">LinkedIn Profile URL</label>
                                                <Field
                                                    type="text"
                                                    name="repLinkedIn"
                                                    placeholder="https://linkedin.com/in/johndoe"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="repLinkedIn" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Phone Number *</label>
                                                <div className="d-flex gap-2 relative">
                                                    <div className="flex w-full">
                                                        <div className="w-[32%] flex-shrink-0 fds">
                                                            <Select
                                                                name="countryCode"
                                                                options={countryCodeOptions}
                                                                value={countryCodeOptions.find((option) => option.value === values.countryCode && option.label == selectedCountryCodeName) || null}
                                                                onChange={(option) => {
                                                                    setCountryCode(option ? option.value : "");
                                                                    setTempCountryCode(option ? option.value : "");
                                                                    setFieldValue("countryCode", option ? option.value : "");
                                                                    // setIsPhoneVerified(
                                                                    //     phoneNumber === originalPhone && option?.value === formValues.countryCode
                                                                    // );
                                                                    setSelectedCountryCodeName(option ? option.label : "");
                                                                }}
                                                                onFocus={() => {
                                                                    setFieldValue("countryCode", "");
                                                                    setCountryCode("");
                                                                }}
                                                                onBlur={() => {
                                                                    if (!values.countryCode && tempCountryCode) {
                                                                        setFieldValue("countryCode", tempCountryCode);
                                                                        setCountryCode(tempCountryCode);
                                                                    }
                                                                }}
                                                                placeholder="Select Country"
                                                                className="react-select-container rounded-r-none border-r-0 fomc-cls custom-select"
                                                                classNamePrefix="react-select"
                                                                aria-label="Select Country Code"
                                                                inputProps={{ autoComplete: "off" }}
                                                                autoComplete="off"
                                                                isDisabled={isPhoneVerified}
                                                                isClearable={false}
                                                            />
                                                        </div>
                                                        <Field
                                                            type="text"
                                                            name="phone"
                                                            placeholder="+1 234 567 890"
                                                            className="form-control flex-grow-1 rounded-l-none !border-l-0 w-[12%] fomc-cls mr-[10px]"
                                                            onChange={(e) => {
                                                                const newPhone = e.target.value;
                                                                setPhoneNumber(newPhone);
                                                                handleChange(e);
                                                                // setIsPhoneVerified(
                                                                //     newPhone === originalPhone && values.countryCode === formValues.countryCode
                                                                // );
                                                            }}
                                                            disabled={isPhoneVerified}
                                                        />
                                                        {/* <Button
                                                            onClick={() => sendOTP(phoneNumber)}
                                                            disabled={phoneNumber.length !== 10 || loading || !values.countryCode}
                                                            className="btn-explore-yellow w-[20%] ml-2"
                                                        >
                                                            {isPhoneVerified ? "Edit" : "Verify"}
                                                        </Button> */}
                                                        <ButtonsVariant
                                                            ariaLabel="button"
                                                            href="#"
                                                            className="mx-[10px] h-max mt-[5px]"
                                                            variant="blackToWhite"
                                                            size="xs"
                                                            title={isPhoneVerified ? "Edit" : "Verify"}
                                                            onClick={() => sendOTP(phoneNumber)}
                                                            disabled={loading || !values.countryCode}
                                                        />
                                                    </div>
                                                </div>
                                                <ErrorMessage name="phone" component="p" className="text-red-500 text-xs mt-1" />
                                                {otpError && <p className="text-red-500 text-xs mt-1">{otpError}</p>}
                                            </Col>
                                        </Row>
                                        <hr className="my-4 border-t border-gray-500" />

                                        {/* Document Upload */}
                                        <div className="text-lg font-bold text-gray-900 modal-title h4 mt-4 mb-4">Business Documents</div>
                                        <Row>
                                            <Col md={12} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">
                                                    Document Upload
                                                </label>
                                                <span className="text-gray-500"><small>Note : To verify your business, proof of registration and authentication is needed. If you don’t have them right now, you can upload the documents later from Organization Settings.</small></span>
                                                <MediaUpload
                                                    onUpload={handleMediaUpload}
                                                    mediaFiles={mediaFiles}
                                                    setError={setError}
                                                />
                                                <MediaPreview mediaFiles={mediaFiles} onRemove={handleRemoveMedia} />
                                                {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
                                                <label className="block text-sm font-semibold text-gray-600">
                                                    PDF, PNG, JPG, DOC, DOCX format: <small>Max Size 1 MB</small>
                                                </label>
                                            </Col>
                                        </Row>
                                        <hr className="my-4 border-t border-gray-500" />

                                        {/* Optional Secondary Contact */}
                                        <div className="text-lg font-bold text-gray-900 modal-title h4 mt-4 mb-4">Optional Secondary Contact</div>
                                        <Row>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Secondary Contact Email</label>
                                                <Field
                                                    type="text"
                                                    name="secEmail"
                                                    placeholder="secondary@email.com"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="secEmail" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                            <Col md={6} className="pb-2">
                                                <label className="block text-sm font-semibold text-gray-600">Secondary Contact Phone</label>
                                                <Field
                                                    type="text"
                                                    name="secContact"
                                                    placeholder="+1 999 888 7777"
                                                    className="form-control fomc-cls px-3 py-2"
                                                    onChange={handleChange}
                                                />
                                                <ErrorMessage name="secContact" component="p" className="text-red-500 text-xs mt-1" />
                                            </Col>
                                        </Row>
                                        <hr className="my-4 border-t border-gray-500" />

                                        <div className="mt-6 flex justify-end gap-4">
                                            <Button
                                                className={` ${!isPhoneVerified
                                                    ? "btn-explore-yellow-disabled !border-gray-300 !border-[1px] disabled:!cursor-not-allowed disabled:!bg-gray-300 disabled:opacity-50 disabled:hover:!border-gray-300 disabled:hover:!bg-gray-300 disabled:!text-white disabled:hover:!text-white"
                                                    : "btn-explore-yellow"
                                                    }`}
                                                type="submit"
                                                disabled={!isPhoneVerified}
                                            >
                                                Submit Form
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Col>
                    </Row>
                </Container>
                {loading ? (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50">
                        <Loader />
                    </div>
                ) : (
                    showOTPModal && (
                        <Modal show={showOTPModal} onHide={() => setShowOTPModal(false)} centered backdrop="static" keyboard={false}>
                            <Modal.Header closeButton>
                                <Modal.Title className="text-black">Verify OTP</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p style={{ color: '#000000' }}>Enter the OTP sent to {countryCode}{phoneNumber}</p>
                                <input
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    className="form-control fomc-cls px-3 py-2"
                                    placeholder="Enter OTP"
                                />
                                {otpError && <p className="text-red-500 text-xs mt-1">{otpError}</p>}
                            </Modal.Body>
                            <Modal.Footer className="mt-[10px]">
                                {/* <Button
                                    className="btn-explore-white"
                                    onClick={verifyOTP}
                                    disabled={otp.length !== 6 || loading}
                                >
                                    Verify OTP
                                </Button> */}

                                <ButtonsVariant
                                    ariaLabel="button"
                                    onClick={verifyOTP}
                                    disabled={otp.length !== 6 || loading}
                                    href="#"
                                    className="mx-[10px]"
                                    variant="blackToWhite"
                                    size="xs"
                                    title="Verify OTP"
                                />
                            </Modal.Footer>
                        </Modal>
                    )
                )}
            </section>
            {popupData.isOpen && (
                <Confin
                    isOpen={popupData.isOpen}
                    title={popupData.title}
                    message={popupData.message}
                    onClose={popupData.onClose}
                    onConfirm={popupData.onConfirm}
                    showCancelButton={popupData.showCancelButton}
                    cancelButtonText={popupData.cancelButtonText}
                    onCancel={popupData.onCancel}
                    actionType={popupData.actionType}
                />
            )}
            <FooterStyle theme="light" className="bg-black text-[#828282]" />
            <WelcomePopupBus isOpen={isPopupOpen} onClose={handleClosePopup} />
        </div>
    );
};

export default BusinessForm;